<template>
  <div
    v-if="internalValue"
    id="applicant-internal-profile-form"
    class="applicant-show-form"
  >
    <div class="vx-row">
      <div class="vx-col w-full md:w-1/2">
        <DataInput
          v-model="internalValue.shortProfileDescription"
          type="html"
          class="w-full"
          label="Kurzprofil"
          name="shortProfileDescription"
        />
      </div>
      <div v-if="!hideRating" class="vx-col w-full md:w-1/2">
        <DataInput
          v-model="internalValue.internalRatingComment"
          type="html"
          class="w-full"
          label="Bewertung (vertraulicher Bericht)"
          name="internalRatingComment"
        />
      </div>
    </div>
    <h2 class="mt-8">Profilauswahl</h2>
    <div>
      Bitte wählen Sie aus, welche Daten im Profil angezeigt werden sollen:
    </div>

    <div class="vx-row">
      <div class="vx-col">
        <DataInput
          v-model="internalValue.showPicture"
          type="bool"
          class="w-full mt-4"
          label="Foto"
          name="showPicture"
        />
      </div>

      <!-- <div class="vx-col">
        <DataInput
          v-model="internalValue.exportGender"
          type="bool"
          class="w-full mt-4"
          label="Geschlecht"
          name="exportGender"
        />
      </div> -->

      <div class="vx-col">
        <DataInput
          v-model="internalValue.exportName"
          type="bool"
          class="w-full mt-4"
          label="Name"
          name="exportName"
        />
      </div>

      <div class="vx-col">
        <DataInput
          v-model="internalValue.exportAdress"
          type="bool"
          class="w-full mt-4"
          label="Ort"
          name="exportAdress"
        />
      </div>

      <div class="vx-col">
        <DataInput
          v-model="internalValue.exportShortDescription"
          type="bool"
          class="w-full mt-4"
          label="Kurzprofil"
          name="exportShortDescription"
        />
      </div>

      <div class="vx-col">
        <DataInput
          v-model="internalValue.exportInternalRating"
          type="bool"
          class="w-full mt-4"
          label="Bewertung"
          name="exportInternalRating"
        />
      </div>
    </div>
    <div class="vx-row">
      <div class="vx-col w-full lg:w-1/2">
        <DataInput
          v-model="internalValue.exportNameMasking"
          type="select"
          :options="exportNameMaskings"
          class="w-full mt-4"
          label="Anonymisierungstyp"
          name="exportNameMasking"
        />
      </div>
      <div class="vx-col w-full lg:w-1/2">
        <DataInput
          v-model="internalValue.consultantID"
          :initial-value="internalValue.consultant"
          type="model"
          class="w-full mt-4"
          label="Berater"
          name="consultant"
          model-label="
            firstName
            lastName"
          :select-label="el => el.firstName + ' ' + el.lastName"
          gql-query="consultantsPage"
          gql-single-query="consultant"
          gql-filter-type="objectFilter"
        />
      </div>
    </div>
    <div class="vx-row">
      <div class="vx-col w-full md:w-1/6">
        <DataInput
          v-model="internalValue.exportNegotioation"
          type="bool"
          class="w-full mt-4"
          label="Personalvermittlung"
          name="exportNegotioation"
        />
      </div>
      <div class="vx-col w-full md:w-5/6">
        <DataInput
          v-model="internalValue.commissionAmount"
          type="number"
          class="w-full mt-4"
          label="Vermittlungsprovision (%)"
          name="commissionAmount"
          min="0"
          max="80"
        />
      </div>
    </div>
  </div>
</template>

<script>
import DataInput from "@/components/ui/DataInput";
import exportNameMaskings from "@/data/enums/ExportNameMasking.js";

export default {
  components: {
    DataInput
  },
  props: {
    value: { type: Object, required: true },
    hideRating: { type: Boolean, default: false }
  },
  data: () => ({
    exportNameMaskings
  }),
  computed: {
    internalValue: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      }
    }
  },
  watch: {
    internalValue: {
      deep: true,
      handler: function(v) {
        this.internalValue = v;
      }
    }
  }
};
</script>
